import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    margin: {
        width: '120px',
        textTransform: 'none',
      },

  }));
  
/**
 * data ve více sloupcích (20 dolů *5 = 100)
 */
  export default function DetailTable(props) {
   
        const classes = useStyles();    
        return (
            <div>
                <h3>Přihlášené osoby</h3>
                <p>(Místo jména je zobrazeno číslo pod kterým jste se přihlásili.)            </p>
                <div className={classes.root}>
                 {props.myData.map((item, index) =>
                     <Button className={classes.margin} variant="contained" >
                        {item.res_id + " (Osob:"+ item.res_count + ")"}
                     </Button>
                    )
                    }
                </div>

            </div>
        )
    }

